import React from "react";
import AlertIcon from "../../Common/Svgs/AlertIcon";

const Screen7 = ({ onClick, error }) => {
  return (
    <div className="flex flex-col">
      <h1 className="font-poppins text-2xl text-background-white font-semibold text-center">
        All set!
      </h1>

      <p className="mt-4 font-poppins text-sm font-normal text-background-white-hover text-center">
        Thanks for providing the details! Your dashboard is ready.
      </p>

      {error ? (
        <div className="mt-4 flex items-center justify-center gap-x-2">
          <AlertIcon className="text-white" />

          <p className="font-poppins text-sm font-normal text-background-white-hover">
            {error}
          </p>
        </div>
      ) : null}

      <button
        type="button"
        className="mt-[111px] w-full h-[42px] py-3 rounded-md bg-yellow hover:bg-yellow-dark"
        onClick={onClick}
      >
        <p className="font-poppins text-xs font-medium">Go to dashboard</p>
      </button>
    </div>
  );
};

export default Screen7;
